/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Whether the student's current focus appears acceptable or still weak.
 */
export type AiTutorFormativeFeedbackFocusQualityAssessment =
  (typeof AiTutorFormativeFeedbackFocusQualityAssessment)[keyof typeof AiTutorFormativeFeedbackFocusQualityAssessment];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiTutorFormativeFeedbackFocusQualityAssessment = {
  acceptable: 'acceptable',
  weak: 'weak',
  unknown: 'unknown',
} as const;
